import { TELEPHONE_PRETTY } from '@mindfulchefuk/constants'

export const CARD_FAILED_TEXT =
  'Your card details have not been updated. Please either try again, contact your bank, or use a different card'

export const CHECKOUT_ERROR = 'There has been an error during checkout'
export const GENERIC_ERROR = `Please call customer services on ${TELEPHONE_PRETTY}.`
